import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_almond_croissant.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganAlmondCroissant() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Almond Croissant",
    content_category: "Vegan Menu",
    content_ids: ["vegan_almond_croissant"],
    content_type: "vegan_pastries",
    value: 4.25,
    currency: "USD",
  });

  const pageTitle = "Vegan Almond Croissant | Đông Hưng Viên Bakery";
  const pageDescription =
    "A flaky vegan croissant filled with smooth almond cream and baked until golden for a finish that feels crisp and indulgent.";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Vegan Almond Croissant"
          titleSubHead="$4.25 each"
          detailBody="A flaky vegan croissant filled with smooth almond cream and baked until golden for a finish that feels crisp and indulgent."
          detailBodyBr="Contains: wheat, almond, sesame"
          detailBody3="Vegan"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganAlmondCroissant;